/**
 * `/get` — تنها کارش این است که بفهمد روی چه دستگاهی باز شده و بفرستدت جای
 * درست.
 *
 * ═══ چرا این صفحه وجود دارد ═══
 *
 * به‌خاطرِ QR. QR یک تصویرِ ثابت است و نمی‌داند چه کسی اسکنش می‌کند: اگر
 * مستقیم به گوگل‌پلی اشاره می‌کرد، هر آیفونی که اسکنش می‌کرد به یک صفحه‌ی
 * بی‌فایده می‌رسید. پس QR به این‌جا اشاره می‌کند و تصمیم روی همان دستگاهی
 * گرفته می‌شود که اسکن کرده — جایی که واقعاً معلوم است اندروید است یا iOS.
 *
 * همین صفحه برای هر لینکِ «اپ رو بگیر» در هر جای دیگر هم درست کار می‌کند،
 * پس اگر فردا جای دیگری لازم شد، همین یکی است.
 *
 * روی دسکتاپ هیچ‌جا نمی‌فرستد — آن‌جا مقصدی نیست که به درد بخورد — و
 * به‌جایش همان چیزی را نشان می‌دهد که پایینِ صفحه‌های مهمان هم هست: هر دو
 * فروشگاه، و یک QR. عمداً از `StoreBadge` می‌آید و این‌جا دوباره نوشته
 * نمی‌شود، وگرنه روزی یکی‌شان از دیگری عقب می‌ماند.
 */
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { storeUrlFor } from '@/core/lib/appStore';
import { t, useLocale } from '@/core/lib/i18n';
import { Card } from '@/ui/kit';
import { StoreBadge } from '@/ui/StoreBadge';

export function GetAppPage() {
  useLocale();

  const ua = typeof navigator === 'undefined' ? '' : navigator.userAgent;
  const touch = typeof navigator === 'undefined' ? 0 : (navigator.maxTouchPoints ?? 0);
  const store = storeUrlFor(ua, touch);

  useEffect(() => {
    // `replace` و نه `assign`: دکمه‌ی برگشتِ مرورگر باید به جایی برگردد که
    // کاربر واقعاً بود، نه به این صفحه‌ی واسط که بلافاصله دوباره می‌فرستدش.
    if (store) window.location.replace(store);
  }, [store]);

  return (
    <div className="feed guest">
      <h1 className="feed-title">{t('joinSmall')}</h1>

      <Card className="get-app">
        {/* روی گوشی این‌ها یک پلک دیده می‌شوند و بعد مرورگر می‌رود؛ ولی اگر
            آن پرش به هر دلیلی نگرفت — مرورگرِ سخت‌گیر، اپِ داخلیِ یک پیام‌رسان —
            صفحه هنوز کارِ خودش را می‌کند و هر دو راه سرِ جایشان‌اند. */}
        {store ? <p className="dim">{t('redirecting')}</p> : null}
        <StoreBadge />
      </Card>

      <p className="dim guest-home"><Link to="/">{t('backToSite')}</Link></p>
    </div>
  );
}
